<template>
  <div>
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Incidencias albaranes</h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral" @click="loadList" :loading="loading">
            <i class="fas fa-sync mr-2"></i> Actualizar
          </base-button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card body-classes="px-0 pb-1" footer-classes="pb-2">
            <div class="p-2">
              <p class="text-muted mb-3">
                Listado de incidencias sobre consumibles (material sin número de serie) de los albaranes.
              </p>
              <div class="table-responsive">
                <el-table
                  class="table-responsive align-items-center table-flush"
                  header-row-class-name="thead-light"
                  :data="items"
                  v-loading="loading"
                  element-loading-text="Cargando..."
                  empty-text="No hay incidencias de albaranes"
                >
                  <el-table-column label="Albarán" min-width="120">
                    <template v-slot="{ row }">
                      <router-link
                        v-if="getAlbaranId(row)"
                        :to="{ name: 'View Albaran', params: { id: getAlbaranId(row) } }"
                        class="font-weight-bold"
                      >
                        #{{ getAlbaranId(row) }}
                        <i class="fas fa-external-link-alt ml-1 small"></i>
                      </router-link>
                      <span v-else class="text-muted">—</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Material" min-width="180">
                    <template v-slot="{ row }">
                      {{ getMaterialNombre(row) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Cantidad" width="100" align="center">
                    <template v-slot="{ row }">
                      {{ row.cantidad_afectada }} ud.
                    </template>
                  </el-table-column>
                  <el-table-column label="Motivo" width="140">
                    <template v-slot="{ row }">
                      {{ getMotivoLabel(row.motivo_consumible) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Estado" width="120">
                    <template v-slot="{ row }">
                      <span class="badge" :class="getEstadoBadgeClass(row)">
                        {{ getEstadoNombre(row) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Fecha" width="110">
                    <template v-slot="{ row }">
                      {{ formatDate(row.fecha) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Descripción" min-width="150">
                    <template v-slot="{ row }">
                      <span class="text-muted small">{{ row.descripcion || '—' }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div slot="footer" class="col-12 d-flex justify-content-between flex-wrap">
              <p class="card-category mb-0">
                Total: {{ items.length }} incidencia(s)
              </p>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/es';

export default {
  layout: 'DashboardLayout',
  data() {
    return {
      items: [],
      loading: false,
      apiUrl: process.env.VUE_APP_API_URL || 'https://misepis-api.delfromsoftware.com/api',
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    async loadList() {
      this.loading = true;
      try {
        const res = await axios.get(
          `${this.apiUrl}/incidencia-albarans?pagination[pageSize]=500&sort=createdAt:desc&filters[albaran_activo_material][id][$notNull]=true&populate[albaran_activo]=*&populate[albaran_activo_material]=*&populate[estado_incidencia]=*`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          }
        );
        const raw = res.data?.data || [];
        this.items = raw.map((x) => {
          const att = x.attributes || {};
          return {
            id: x.id,
            ...att,
            albaran_activo: att.albaran_activo?.data ?? att.albaran_activo,
            albaran_activo_material: att.albaran_activo_material?.data ?? att.albaran_activo_material,
            estado_incidencia: att.estado_incidencia?.data ?? att.estado_incidencia,
          };
        }).filter((item) => {
          const m = item.albaran_activo_material;
          return Boolean(m?.id ?? m?.data?.id);
        });
      } catch (e) {
        console.error('Error cargando incidencias albaranes:', e);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    getAlbaranId(row) {
      const a = row.albaran_activo;
      return a?.id ?? a?.data?.id;
    },
    getMaterialNombre(row) {
      const m = row.albaran_activo_material?.attributes ?? row.albaran_activo_material;
      if (!m) return '—';
      return m.descripcion || m.nombre || m.idArticulo || 'Consumible';
    },
    getMotivoLabel(motivo) {
      const map = {
        perdida: 'Pérdida',
        rotura: 'Rotura',
        no_retorna_taller: 'No retorna a taller',
        otro: 'Otro',
      };
      return map[motivo] || motivo || '—';
    },
    getEstadoNombre(row) {
      const e = row.estado_incidencia?.attributes ?? row.estado_incidencia;
      return e?.nombre ?? 'Abierta';
    },
    getEstadoBadgeClass(row) {
      const nom = (this.getEstadoNombre(row) || '').toLowerCase();
      if (nom.includes('resuelta') || nom.includes('cerrada')) return 'badge-success';
      return 'badge-warning';
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '—';
    },
  },
};
</script>
